"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DynamicFormattedMessage = require("./DynamicFormattedMessage");
Object.keys(_DynamicFormattedMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DynamicFormattedMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DynamicFormattedMessage[key];
    }
  });
});
var _FormattedMessage = require("./FormattedMessage");
Object.keys(_FormattedMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormattedMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormattedMessage[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
//# sourceMappingURL=index.js.map